import { getEmailTokenFromQuery } from '../../helpers/queryParamsHelpers.ts';

import { USER_EMAIL_TOKEN } from './constants.ts';

export function getEmailToken(): string | JsonType {
    return getEmailTokenFromQuery() || localStorage.getItem(USER_EMAIL_TOKEN) || undefined;
}
